import React, { useState, useEffect } from "react";
import dashboardclasses from "../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { config } from "../../s3config";
import S3FileUpload from "react-s3";
import { v4 as uuid } from "uuid";
import { AiOutlineClose } from "react-icons/ai";
import { ToastError } from "../../Components/utils/ToastMessage";
import {
    validateEmptySpaces,
    validateNegativeValuesonly,
    validateNegativeValues,
} from "../../Components/utils/validations";
window.Buffer = window.Buffer || require("buffer").Buffer;
function AddCategory(props) {
    const [categories, setcategories] = useState([]);
    const Navigate = useNavigate();
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm();
    const [base64, setbase64] = useState([]);
    const [img, setImage] = useState("");
    const [descriptionImage, setdescriptionImage] = useState("");
    const getcategories = () => {
        Services.Get_Omnimart_Categories("GET", null, token)
            .then((res) => {
                if (res.Status === 1) {
                    setcategories(res.Categories);
                    console.log(props.editable);
                    if (props.editable) {
                        reset({
                            ...props.editable,
                            categoryId: `${props.editable.categoryId}`,
                        });
                    }
                } else if (res.Status === 0) {
                    ToastError(res.Message);
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    useEffect(() => {
        getcategories();
        if (props.editable) {
            setImage({
                location: props.editable.image,
                fileName: props.editable.image.split("/").splice(-1)[0],
            });
            setdescriptionImage({
                location: props.editable.descriptionImage,
                fileName: props.editable.descriptionImage
                    .split("/")
                    .splice(-1)[0],
            });
            setbase64(props.editable.images);
        }
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };
    const deleteHandler = (e) => {
        let id = e.currentTarget.getAttribute("id");
        setbase64((prev) => prev.filter((item) => item.id != id));
    };
    const handleChange = (files) => {
        if (base64.length + files.length > 5) {
            alert("Uploading more than 5 files is not permitted");
            return;
        } else {
            let formData = new FormData();
            formData.append("folder", "Products");
            formData.append("bucketName", "heyman-s3");
            Object.keys(files).every((key) => {
                if (
                    files[key].type === "image/png" ||
                    files[key].type === "image/jpeg"
                ) {
                    formData.append("images", files[key]);
                    /*  S3FileUpload.uploadFile(newfile, {
                        ...config,
                    })
                        .then((res) => {
                            console.log(res);
                            let data = {
                                fileType: String(files[key].type).split("/")[0],
                                location: res.location,
                                fileName: `${timestamp}.${
                                    String(files[key].type).split("/")[1]
                                }`,
                                id: uuid(),
                            };
                            console.log(data);
                            setbase64((prev) => [...prev, data]);
                        })
                        .catch((err) => {
                            alert(err);
                            console.log(err);
                        }); */
                } else {
                    alert(`${files[key].name} is neither image Nor PDF`);
                    return false;
                }
                return true;
            });

            Services.UploadImages("POST", formData, token)
                .then((res) => {
                    let allData = res?.Files.map((item) => ({
                        fileName: item?.ImageID,
                        location: item?.ImageURL,
                        id: uuid(),
                    }));
                    console.log(res, allData);
                    setbase64((prev) => [...prev, ...allData]);
                })
                .catch((err) => {
                    alert(err);
                    console.log(err);
                });
        }
    };
    const handleChange1 = (files, type) => {
        if (files.type === "image/png" || files.type === "image/jpeg") {
            const timestamp = Date.now();
            const newfile = new File(
                [files],
                `${timestamp}.${String(files.type).split("/")[1]}`
            );
            let body = new FormData();
            body.append("image", files);
            body.append("folder", "Products");
            body.append("bucketName", "heyman-s3");

            Services.UploadImage("POST", body, token)
                .then((res) => {
                    console.log(res);

                    let data = {
                        fileType: String(files.type).split("/")[0],
                        location: res.ImageURL,
                        fileName: res?.ImageID,
                        id: uuid(),
                    };
                    console.log(data);
                    if (type == "image") {
                        setImage(data);
                    } else {
                        setdescriptionImage(data);
                    }
                })
                .catch((err) => {
                    alert(err);
                    console.log(err);
                });
        } else {
            alert(`Please upload PNG or jpg images`);
            return false;
        }
    };
    const fileuploadDesign = (
        <div className={dashboardclasses["add-item"]}>
            <BsCloudUpload className={dashboardclasses["upload-icon"]} />
            <h5>Drag Your Image here</h5>
            <p>(Only *.jpeg and *.png images will be accepted)</p>
        </div>
    );
    const onSubmit = (data) => {
        let categoryId = categories.filter(
            (item) => item.categoryId == data.categoryId
        );
        let body = {
            ...data,
            images: base64.map((item) => item.fileName),
            image: img.fileName,
            descriptionImage: descriptionImage.fileName,
        };
        if (categoryId.length > 0) {
            body = { ...body, category: categoryId[0].name };
        }
        if (!props.editable) {
            Services.add_Products("POST", JSON.stringify(body), token)
                .then((res) => {
                    props.tableload(false);
                    if (res.Status === 1) {
                        props.setforcepage(0);
                        Navigate(`/Products?page=${1}`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories(0);
                        props.setEditable(false);

                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    props.tableload(false);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        } else if (props.editable) {
            Services.update_Products(
                "PUT",
                JSON.stringify(body),
                token,
                props.editable.productId
            )
                .then((res) => {
                    if (res.Status === 1) {
                        props.setforcepage(0);
                        Navigate(`/Products?page=${1}`);
                        props.setpageCount(1);
                        props.setmodal(false);
                        props.tableload(true);
                        props.getCategories(0);
                        props.setEditable(false);
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };

    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable ? "Update Product" : "Add Product"}
                        </h3>
                        <p>
                            {props.editable ? "Update Product" : "Add Product"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Product Name</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("name", {
                                    required: "name is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.name && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.name?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="brand">Brand</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("brand", {
                                    required: "Brand is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.brand && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.brand?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryname">Category Name</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                defaultValue={""}
                                {...register("categoryId", {
                                    required: "category name is required",
                                })}>
                                <option value="" disabled>
                                    Select Category
                                </option>
                                {categories.map((item) => (
                                    <option value={item.categoryId}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            {errors?.categoryId && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.categoryId?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    {/* <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Offer Category</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("offercategory", {
                                    required: "offercategory is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.offercategory && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.offercategory?.message}
                                </p>
                            )}
                        </div>
                    </div> */}

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Image</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={(file) => {
                                handleChange1(file, "image");
                            }}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <div></div>
                        <div
                            style={{
                                display: "grid",
                                gap: "0.4rem",
                                gridTemplateColumns: "1fr 1fr",
                                justifyItems: "left",
                                width: "70%",
                            }}>
                            {img?.location && (
                                <div
                                    className={
                                        dashboardclasses[
                                            "subcategory-img-wrapper"
                                        ]
                                    }>
                                    <img
                                        src={img.location}
                                        alt=""
                                        width={"120px"}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Description Image</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={(file) => {
                                handleChange1(file, "descriptionImage");
                            }}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <div></div>
                        <div
                            style={{
                                display: "grid",
                                gap: "0.4rem",
                                gridTemplateColumns: "1fr 1fr",
                                justifyItems: "left",
                                width: "70%",
                            }}>
                            {descriptionImage?.location && (
                                <div
                                    className={
                                        dashboardclasses[
                                            "subcategory-img-wrapper"
                                        ]
                                    }>
                                    <img
                                        src={descriptionImage.location}
                                        alt=""
                                        width={"120px"}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Images</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={true}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                            // types={fileTypes}
                        />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <div></div>
                        <div
                            style={{
                                display: "grid",
                                gap: "0.4rem",
                                gridTemplateColumns: "1fr 1fr",
                                justifyItems: "left",
                                width: "70%",
                            }}>
                            {base64?.map((item) => (
                                <div
                                    className={
                                        dashboardclasses[
                                            "subcategory-img-wrapper"
                                        ]
                                    }>
                                    <button
                                        type="button"
                                        name={item.name}
                                        id={item.id}
                                        onClick={deleteHandler}>
                                        <AiOutlineClose />
                                    </button>
                                    <img
                                        src={item.location}
                                        alt=""
                                        width={"120px"}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">sku</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("sku", {
                                    required: "sku is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.sku && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.sku?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">skulink</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("skulink", {
                                    required: "Skulink is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.skulink && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.skulink?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">MRP</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("mrp", {
                                    required: "MRP is required",
                                    validate: validateNegativeValues,
                                })}
                            />

                            {errors?.mrp && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.mrp?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">DMRP</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("dmrp", {
                                    required: "DMRP is required",
                                    validate: validateNegativeValues,
                                })}
                            />

                            {errors?.dmrp && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.dmrp?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="gst">GST</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("gst", {
                                    required: "gst is required",
                                    validate: validateNegativeValuesonly,
                                })}
                            />

                            {errors?.gst && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.gst?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="bufferstockqty">Buffer stock qty</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("bufferstockqty", {
                                    required: "bufferstockqty is required",
                                    validate: validateNegativeValuesonly,
                                })}
                            />

                            {errors?.bufferstockqty && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.bufferstockqty?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Unit</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="text"
                                {...register("qty", {
                                    required: "qty is required",
                                    validate: validateEmptySpaces,
                                })}
                            />

                            {errors?.qty && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.qty?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Off</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                {...register("off", {
                                    required: "off is required",
                                    validate: validateNegativeValuesonly,
                                })}
                            />

                            {errors?.off && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.off?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Searchkey</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="text"
                                {...register("searchkey", {
                                    required: "Searchkey is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.searchkey && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.searchkey?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">HSN CODE</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="text"
                                {...register("hsncode", {
                                    required: "HSN Code is required",
                                    validate: validateEmptySpaces,
                                })}
                            />
                            {errors?.hsncode && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.hsncode?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Description</label>
                        <div className={dashboardclasses["select"]}>
                            <textarea
                                name=""
                                id=""
                                {...register("description", {
                                    required: "description is required",
                                    validate: validateEmptySpaces,
                                })}></textarea>
                            {errors?.description && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.description?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable ? "update" : "Add Product"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
